import {
  Conversation,
  TwilioUser,
} from 'models/twilio';
import { CUSTOM_USERS } from '../constants';

const getMissingUsers = async (
  conversation: Conversation,
  userEntities: Record<string, TwilioUser>,
  requiredUserIds: string[],
) => {
  const missingUserIds = requiredUserIds.filter((userId) => !CUSTOM_USERS.includes(userId) && !userEntities[userId]);
  if (missingUserIds.length) {
    const participants = await Promise.all(missingUserIds.map((userId) => conversation.getParticipantByIdentity(userId)));
    try {
      await Promise.all(participants.map((participant) => participant.getUser()));
    } catch (e) {
      console.error(e.message);
    }
  }
};

export default getMissingUsers;
